module.exports = __webpack_public_path__ + "../static/img/ELdZ_ml_cmyk_en.92abee6d.jpg";